document.addEventListener('DOMContentLoaded', function() {

    //Main section gallery logic
    const galleryImages = document.querySelectorAll('.cmp-single-gallery-img');
    const mainImg = document.getElementById('cmp-main-img');

    galleryImages.forEach(img => {
        img.addEventListener('click', () => {
            mainImg.src = img.src;
            mainImg.alt = img.alt;

            // Add active class to the clicked image and remove it from others
            galleryImages.forEach(otherImg => {
                otherImg.classList.remove('active');
            });
            img.classList.add('active');
        });
    });


    


    //Getting total price logic
    setTimeout(function () {
        const checkboxes = document.querySelectorAll('.cmp-fbt-product-check');
        const totalPriceElement = document.getElementById('cmp-fbt-total-price-id');
        const totalCheckedElement = document.getElementById('cmp-fbt-total-nop');
        let totalPrice = 0;
        let totalChecked = 0

        console.log('this is checkboxes : ', checkboxes)
        checkboxes.forEach(checkbox => {
            const price = parseFloat(checkbox.getAttribute('data-price'));
            checkbox.checked = true; // Check all checkboxes by default
            totalPrice += price;
            totalChecked++;

            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    totalPrice += price;
                    totalChecked++;
                } else {
                    totalPrice -= price;
                    totalChecked--;
                }

                totalPriceElement.textContent ='Rs. ' + (totalPrice / 100 ).toFixed(2);
                totalCheckedElement.textContent = totalChecked;
            });
            totalPriceElement.textContent = 'Rs. ' + (totalPrice / 100 ).toFixed(2)
            totalCheckedElement.textContent = totalChecked;
        });

         // Add event listener to "Add items to cart" button
        const addToCartButton = document.querySelector('.cmp-fbt-atc-btn');
        addToCartButton.addEventListener('click', async () => {
            const selectedProducts = [];

            checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                selectedProducts.push({
                id: Number(checkbox.id),
                quantity: 1, // You can adjust the quantity as needed
                });
            }
            });

            if (selectedProducts.length > 0) {
            try {
                const response = await fetch('/cart/add', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: selectedProducts,
                    }),
                });

                if (response.ok) {
                    // Redirect to the cart page
                    window.location.href = '/cart';
                } else {
                    console.error('Failed to add products to the cart.');
                }
            } catch (error) {
                console.error('An error occurred while adding products to the cart:', error);
            }
            }
        });
    }, 3000);


    //Delivery calculation + 7 days after today's date logic
    // Get the current date and add 7 days to it
    let del_days = document.getElementById('cmp-zip-value').getAttribute('data-delivery-days')

    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + Number(del_days));

    // Get the day and month names for the updated date
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var dayName = days[currentDate.getDay()];
    var monthName = months[currentDate.getMonth()];
    var dayNumber = currentDate.getDate();

    // Format the updated date
    var formattedDate = "Delivery by " + dayName + ", " + dayNumber + " " + monthName;

    // Update the HTML element with the formatted date
    document.getElementById("custom-delivery-date").innerHTML = formattedDate;
    //zip code checker
    const zipBtn = document.getElementById('cmp-zip-check-btn');
    zipBtn.addEventListener('click', async function (){
        let subTitle = document.getElementById("custom-delivery-date")
        let enteredZipcode = document.getElementById('cmp-zip-value')
        
        let softWarning = enteredZipcode.getAttribute('data-soft-warning')
        let hardWarning = enteredZipcode.getAttribute('data-hard-warning')
        let invalidZipcodes = enteredZipcode.getAttribute('data-zip')
        
        
        invalidZipcodes = invalidZipcodes.replace(' ','')
        invalidZipcodes = invalidZipcodes.split(',')
        
        
        console.log('unvalid', invalidZipcodes)
        console.log('first', enteredZipcode.value)
        zipBtn.textContent = "Checking"
        let apiValid = false
        const res = await fetch(`https://api.postalpincode.in/pincode/${enteredZipcode.value}`)
        const resData = await res.json()
        console.log(resData)
        if(resData[0].Status === "Success"){
            apiValid = true
        }
        else{
            apiValid = false
        }
        
        const indianPincodeRegex = /^[1-9][0-9]{5}$/;

        if(invalidZipcodes.includes(enteredZipcode.value)){
            subTitle.style.color = 'red'
            subTitle.innerHTML = hardWarning
        }
        else if(indianPincodeRegex.test(enteredZipcode.value) !== true){
            subTitle.style.color = 'orange'
            subTitle.innerHTML = 'Please enter valid pincode'
        }
        else{
            if(apiValid){
                subTitle.style.color = 'green'
                subTitle.innerHTML = formattedDate
            }
            else{
                subTitle.style.color = 'orange'
                if(softWarning !== 'NA' && softWarning !== ''){
                    subTitle.innerHTML = softWarning
                }
            }
        }
        zipBtn.textContent = "Check"
    })


    //Product page mobile active dot code
    const slider = document.querySelector('.cmp-img-slider-mb');
    const dots = document.querySelectorAll('.cmp-img-dot-mb');

    dots[0].classList.add('cmp-img-dot-mb-active')
    // Add a scroll event listener to the slider
    slider.addEventListener('scroll', () => {
        const scrollPosition = slider.scrollLeft;
        const imageWidth = slider.offsetWidth;
        const activeImageIndex = Math.round(scrollPosition / imageWidth);

        // Remove 'cmp-img-dot-mb-active' class from all dots
        dots.forEach(dot => dot.classList.remove('cmp-img-dot-mb-active'));

        // Add 'cmp-img-dot-mb-active' class to the active dot
        if (dots[activeImageIndex]) {
            dots[activeImageIndex].classList.add('cmp-img-dot-mb-active');
        }
    });
});